module.exports = __webpack_public_path__ + "img/iveta-kirstukaite-magic-book.6db98a39.jpg";